import { Box, BoxProps, styled } from "@mui/material";

const StyledBox = styled(Box)`
  &:first-child {
    margin-top: ${({ theme }) => theme.spacing(0.5)};
  }

  &:last-child {
    margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  }
` as typeof Box;

function AutocompleteOption(props: BoxProps<"li">) {
  return <StyledBox component="li" {...props} />;
}

export { AutocompleteOption };
